import { featureDefinitions } from './definitions.mjs';
function loadFeatures(features) {
  for (var key in features) {
    if (key === "projectionNodeConstructor") {
      featureDefinitions.projectionNodeConstructor = features[key];
    } else {
      featureDefinitions[key].Component = features[key];
    }
  }
}
export { loadFeatures };